<template>
  <v-footer class="footer-content">
    <v-card
      flat
      tile
      class="footer-content-card text-center"
    >
      <v-card-text>
        <v-btn class="mx-4  text-color" icon href="https://www.facebook.com/genaro.pretillescobar" target="_blank">
          <v-icon size="24px">fab fa-facebook</v-icon>
        </v-btn>
        <v-btn class="mx-4  text-color" icon href="https://twitter.com/gepres" target="_blank">
          <v-icon size="24px">fab fa-twitter</v-icon>
        </v-btn>
        <v-btn class="mx-4  text-color" icon href="https://www.instagram.com/gepres" target="_blank">
          <v-icon size="24px">fab fa-instagram</v-icon>
        </v-btn>
      </v-card-text>

      <v-card-text class= "pt-0 text-color">
       <v-row>
          <v-col cols="12" lg="4" md="4" sm="6" xs="12" >
            <h5 class="headline">Contenidos</h5>
            <ul class="footer-categoria__ul">
              <li class="footer-categoria__li">Historias</li>
              <li class="footer-categoria__li">Novelas</li>
              <li class="footer-categoria__li">Poemas</li>
            </ul>
          </v-col>
          <v-col cols="12" lg="4" md="4" sm="6" xs="12" >
             <h5 class="headline">Historias</h5>
              <ul class="footer-categoria__ul">
                <li class="footer-categoria__li">Viajes</li>
                <li class="footer-categoria__li">Anécdotas</li>
                <li class="footer-categoria__li">Catarsis</li>
              </ul>
          </v-col>
          <v-col cols="12" lg="4" md="4" sm="6" xs="12" >
            <h5 class="headline">Contacto</h5>
            <ul class="footer-categoria__ul">
              <li class="footer-contacto__li"><v-icon class="mr-3">fas fa-map-marker-alt</v-icon> Ica-Perú</li>
              <li class="footer-contacto__li"><v-icon class="mr-3">fas fa-phone</v-icon>+945 335 795</li>
              <li class="footer-contacto__li"><v-icon class="mr-3">fas fa-envelope</v-icon>genaropretill@gmail.com</li>
            </ul>
          </v-col>
       </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-text class="bg-footer-bottom text-color">
        {{ new Date().getFullYear() }} — <strong>Gepres Design</strong>
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
  export default {
    name:'footer-componente',
    data(){
      return {

      }
    }
  }
</script>

<style lang="scss" scoped>
.footer-content{
  padding: 0;
  background:#F5F5F5 !important;
  &-card{
    width: 100% !important;
    background:#F5F5F5 !important;
  }
}
.text-color{
  color:#2F1640 !important;
}
.bg-footer-bottom{
   background:#EEEEEE !important;
}
.footer{
  &-categoria{
    &__ul{
      text-align: start;
      padding-left: 4rem;
    }
    &__li{
      list-style: none;
      border-bottom: 1px solid rgba($color: #283593, $alpha: 0.2);
       padding-top: 1.2rem;
    }
  }
  &-contacto{
    &__li{
      list-style: none;
       padding-top: 1.2rem;
    }
  }
}
</style>